import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,UNSAFE_DataRouterStateContext,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Grid from '@mui/material/Grid';

import moment from "moment";

import multiTransportConcept from '../../Assets/Images/multiTransportConcept11.png'; 
import desktopConcept from '../../Assets/Images/desktopConcept.png'; 
import contactConcept from '../../Assets/Images/contactConcept.png'; 
import formPlaceholder from '../../Assets/Images/formPlaceholder.png'; 
import formTopIcons from '../../Assets/Images/formTopIcons.svg'; 
import cornerTop from '../../Assets/Images/cornerTop.svg';
import cornerBottom from '../../Assets/Images/cornerBottom.svg';

import contactWhatsappIcon from '../../Assets/Images/contactWhatsappIcon.svg';
import contactEmailIcon from '../../Assets/Images/contactEmailIcon.svg';
import contactPhoneIcon from '../../Assets/Images/contactPhoneIcon.svg';
import transportPicture from '../../Assets/Images/transportPicture.svg';
import rentcarPicture from '../../Assets/Images/rentcarPicture.svg';
import transferPicture from '../../Assets/Images/transferPicture.svg';
import transportIcon from '../../Assets/Images/transportIcons.svg';
import transferIcon from '../../Assets/Images/transferIcon.svg';
import rentcarIcon from '../../Assets/Images/rentcarIcon.svg';

import titleTrainIcon from '../../Assets/Images/titleTrainIcon.svg';
import titleBusIcon from '../../Assets/Images/titleBusIcon.svg';
import titleTransferIcon from '../../Assets/Images/titleBusIcon.svg';
import titleRentCarIcon from '../../Assets/Images/titleBusIcon.svg';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

import HeaderView from '../../Components/Layout/Header';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import AlertView from '../../Components/AlertModal';


import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone,
	isJsonString,
	toJsonOrEmpty,	
} from '../../Components/Utils';

import {
	Callto,
	Whatsapp,

} from '../../Components/Utils';

// export default function Reservation() {
const Agency = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	setAgency,
	selectedAgency,
	retrieveAgencies,
	retrieveAgenciesStates,
	retrieveAgenciesComissionProfiles,
	masterUser
} = props;

// Set Overlay obj
const op = React.useRef(null);

const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

// Basic filter fields  and controls
const [basicFilterStatus, setBasicFilterStatus] = React.useState(false);
const [basicFilter, setBasicFilter] = React.useState({});
const [filterValue, setFilterValue] = React.useState("");

// Advanced filter fields and controls
const [advancedFilterStatus, setAdvancedFilterStatus] = React.useState(false);
const [advancedFilter, setAdvancedFilter] = React.useState({});
const [advancedSearch, setAdvancedSearch] = React.useState(false);

// CUSTOM ADVANCED FILTER FIELDS
const [filterByTradingName, setFilterByTradingName] = React.useState("");
const [filterByAgencyName, setFilterByAgencyName] = React.useState("");
const [filterByAgencyDocument, setFilterByAgencyDocument] = React.useState("");
const [filterByResponsibleName, setFilterByResponsibleName] = React.useState("");
const [filterByResponsibleDocument, setFilterByResponsibleDocument] = React.useState("");
const [filterByAgencyPhone, setFilterByAgencyPhone] = React.useState("");
const [filterByAgencyEmail, setFilterByAgencyEmail] = React.useState("");
const [filterByCreateAtFrom, setFilterByCreateAtFrom] = React.useState("");
const [filterByCreateAtTo, setFilterByCreateAtTo] = React.useState("");

const [filterByComissionProfile, setFilterByComissionProfile] = React.useState(null);
const [filterByStatus, setFilterByStatus] = React.useState(null);
const [filterByAgencyState, setFilterByAgencyState] = React.useState(null);
const [filterByAgencyCity, setFilterByAgencyCity] = React.useState("");

// Dropdown Options Advanced filter
const [agenciesStatesOptions, setAgenciesStatesOptions] = React.useState([]);
const [comissionProfilesOptions, setComissionProfilesOptions] = React.useState([]);

// Table row selection
const [selectedItem, setSelectedItem] = React.useState(null);

// Set Fake Data
//var rowsData = ReservationData;
const [rows, setRows] = React.useState([]);
const [totalRecords, setTotalRecords] = React.useState(0);
 
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */

// Select reservation item method
const selectAgencyAction = (value) => {

	// Set local data
	setSelectedItem(value);	

	// Set reservation on store (index 0)
	setAgency(value[0]);

	// Open Modal
	setDialog('agencyModal',true);
	
}

// Retrieve reservations
const retrieveItemsList = () => {
		
	/*var props = {
		setSaving:setSaving,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setRows,
		setLoading:setLoading,
		setTotalRecords:setTotalRecords
	}
	var data = {
	  ...lazyState,
	  status:[1,3,4,9] // Set to retrieve only those status
	}

	retrieveAgencies(data,props);*/

} // end retrieveDocumentInfo


// Retrieve dropdown valures from API
const retrieveDropdownsValues = () => {
		
	/*var props = {
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setAgenciesStatesOptions,
		setLoading:setLoading,
	}
	var data = {
	}
	retrieveAgenciesStates(data,props);

	var props = {
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setComissionProfilesOptions,
		setLoading:setLoading,
	}
	var data = {
	}
	retrieveAgenciesComissionProfiles(data,props);*/

} // end retrieveDropdownsValues

// Dropdown Values for Basic Search Fields
const [filter, setFilter] = React.useState({
	"code": "5",
	"field":"agencyName",
	"name": "Nome da Agência"
});
  
const FilterItems = [
  {
	"code": "5",
	"field":"agencyName",
	"name": "Nome da Agência"
  },  
  {
	"code": "2",
	"field":"customerName",
	"name": "Nome do Responsável"
  },   
   { 
	"code": "4",
	"field":"email",
	"name": "Email"
  }
];
const [dropdownFilterItems, setDropdownFilterItems] = React.useState(FilterItems);

// Datatable default state
const [lazyState, setlazyState] = React.useState({
	first: 0,
	rows: 10,
	page: 1,
	sortField: "createdAt",
	sortOrder: -1,
	filters: {
	}
});

// Default columns
const columnsValues = [
'agencyId',
'agency',
'responsible',
'contacts',
'location',
'profile',
'createdAt',
'status'
];
const [visibleColumns, setVisibleColumns] = React.useState(columnsValues);

// Field value format and enrichement
const bodyTemplate = (type,data) => {

	let rowValue = "Não definido";

	if (type == "agencyId") {

		rowValue = (
		<>
		<div>{data.id}</div>
		</>
		);	
		
	}
	
	if (type == "agency") {		

		rowValue = (
		<>
		<div>{data.companyName}
		
		{/* Set Master Agency Icon */}
		{data.type == 2 &&
		<>
			<svg fill="#814DE5" title="Agência Master" viewBox="0 0 1920 1920" width="15" height="15" style={{}}  xmlns="http://www.w3.org/2000/svg" stroke="#814DE5"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M983.727 5.421 1723.04 353.62c19.765 9.374 32.414 29.252 32.414 51.162v601.525c0 489.6-424.207 719.774-733.779 887.943l-34.899 18.975c-8.47 4.517-17.731 6.889-27.105 6.889-9.262 0-18.523-2.372-26.993-6.89l-34.9-18.974C588.095 1726.08 164 1495.906 164 1006.306V404.78c0-21.91 12.65-41.788 32.414-51.162L935.727 5.42c15.134-7.228 32.866-7.228 48 0ZM757.088 383.322c-176.075 0-319.285 143.323-319.285 319.398 0 176.075 143.21 319.285 319.285 319.285 1.92 0 3.84 0 5.76-.113l58.504 58.503h83.689v116.781h116.781v83.803l91.595 91.482h313.412V1059.05l-350.57-350.682c.114-1.807.114-3.727.114-5.647 0-176.075-143.21-319.398-319.285-319.398Zm0 112.942c113.732 0 206.344 92.724 205.327 216.62l-3.953 37.271 355.426 355.652v153.713h-153.713l-25.412-25.299v-149.986h-116.78v-116.78H868.108l-63.812-63.7-47.209 5.309c-113.732 0-206.344-92.5-206.344-206.344 0-113.732 92.612-206.456 206.344-206.456Zm4.98 124.98c-46.757 0-84.705 37.948-84.705 84.706s37.948 84.706 84.706 84.706c46.757 0 84.706-37.948 84.706-84.706s-37.949-84.706-84.706-84.706Z" fill-rule="evenodd"></path> </g></svg>	
		</>
		}			
		
		</div>
		<div style={{color:"gray"}}>{data.tradingName}</div>
		<div><small style={{color:"gray"}}>{data.CompanyDocument.formattedValue}</small></div>
		</>
		);	
		
	}
	
	if (type == "responsible") {	
			
		rowValue = (
		<>
		<div>{data.completeName}</div>
		<div><small style={{color:"gray"}}>{data.CompanyPersonDocuments[0].formattedValue}</small></div>
		</>
		);				
	}	
	
	if (type == "contacts") {
		
		rowValue = (
		<>
		<div>{maskPhone(data.phone)}</div>
		<div><small style={{color:"gray"}}>{data.email}</small></div>
		</>
		);			
	}	

	if (type == "location") {		
	
		rowValue = (
		<>
		<div>{data.StateLabel}</div>
		<div><small style={{color:"gray"}}>{data.CityLabel}</small></div>
		</>
		);
	}	

	if (type == "governmentData") {		

		let cnaeItem = data.find(item => item.key === "cnae");
		const cnaeData = isJsonString(cnaeItem.value) ? toJsonOrEmpty(cnaeItem.value) : "Não definido";
		
		let situacaoItem = data.find(item => item.key === "situacao");
		const situacaoData = isJsonString(situacaoItem.value) ? toJsonOrEmpty(situacaoItem.value) : "Não definido";
		
		let porteItem = data.find(item => item.key === "porte");
		const porteData = isJsonString(porteItem.value) ? toJsonOrEmpty(porteItem.value) : "Não definido";		

		rowValue = (
			<>
			  <div>{porteData.descricao}</div>
			  <div><small style={{color:"gray"}}>{situacaoData.nome} desde {situacaoData.data}</small></div>
			  <div><small style={{color:"gray"}}>CNAE {cnaeData.subClasse}<br />{cnaeData.descricao}</small></div>
			</>
		);			

	}		
	
	if (type == "creationDate") {		
		rowValue = moment(data.createdAt).format("DD/MM/YYYY")
	}	

	if (type == "profile") {
	
		rowValue = (
		<>
		<div>{data.CompanyComissionGroup.name} ({data.CompanyComissionGroup.alias})</div>
		<div>{data.CompanyProfileGroup.name}</div>

		{/* Set Master Agency Icon */}
		{data.type == 2 &&
		<>
			<div><small style={{color:"gray"}}>Agência Master</small></div>
		</>
		}	

		</>
		);		
		
	}	

	if (type == "status") {		

		if (data.status == 1) {
			var activationStatus = "ativado";
			var activationStatusLabel = "Aprovada";
		} // end if
		else if (data.status == 2) {
			var activationStatus = "bloqueado";
			var activationStatusLabel = "Reprovada";
		} // end if	
		else if (data.status == 3) {
			var activationStatus = "encerrado";
			var activationStatusLabel = "Bloqueado";
		} // end if			
		else if (data.status == 4) {
			var activationStatus = "encerrado";
			var activationStatusLabel = "Cancelado";
		} // end if			 
		else if (data.status == 0) {
			var activationStatus = "review";
			var activationStatusLabel = "Aguardando análise";
		} // end if	
		else if (data.status == 9) {
			var activationStatus = "encerrado";
			var activationStatusLabel = "Excluído";
		} // end if
				
			
		return (
		<>
		<div className={`product-badge status-${activationStatus}`}>{activationStatusLabel}</div>
		</>
		)	
	
		rowValue = data;
	}	
	
    return rowValue;
};
 
const applyBasicSearch = () => {
	
	// Check if search term is filled and with at least 3 chars
	if (!filterValue) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher o termo a ser buscado pra prosseguir.");	
		return;
	} // end if
	
	if (filterValue.length < 3) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Para prosseguir, você precisa preencher o termo a ser buscado com ao menos 3 caracteres.");	
		return;
	} // end if	
 	
	// Set filter on
	setBasicFilterStatus(true);
	
	// Set advanced filter off
	setAdvancedFilterStatus(false);
	
	// Clean Advanced fields
	// Métodos que atualizam os estados para uma string vazia
	setFilterByTradingName("");
	setFilterByAgencyName("");
	setFilterByAgencyDocument("");
	setFilterByResponsibleName("");
	setFilterByResponsibleDocument("");
	setFilterByAgencyPhone("");
	setFilterByAgencyEmail("");  // Mantendo como array vazio, conforme inicialização original
	setFilterByCreateAtFrom("");
	setFilterByCreateAtTo("");
	setFilterByAgencyCity("");

	// Métodos que atualizam os estados para null (mantendo o tipo original)
	setFilterByComissionProfile(null);
	setFilterByStatus(null);
	setFilterByAgencyState(null);
	
	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {
		mode:"basic",
		term: filterValue,
		field: filter
	}
	
	// Set LazyState
	setlazyState(currentData);
	
} // end function

const resetSearch = (type)=> {
	
	if (type == "basic") {
		// Set filter on
		setBasicFilterStatus(false);
		
		// Clean Terms
		setFilterValue("");		
	} // end if
	else {
		// Set filter on
		setAdvancedFilterStatus(false);
		
		// Métodos que atualizam os estados para uma string vazia
		setFilterByTradingName("");
		setFilterByAgencyName("");
		setFilterByAgencyDocument("");
		setFilterByResponsibleName("");
		setFilterByResponsibleDocument("");
		setFilterByAgencyPhone("");
		setFilterByAgencyEmail("");  // Mantendo como array vazio, conforme inicialização original
		setFilterByCreateAtFrom("");
		setFilterByCreateAtTo("");
		setFilterByAgencyCity("");

		// Métodos que atualizam os estados para null (mantendo o tipo original)
		setFilterByComissionProfile(null);
		setFilterByStatus(null);
		setFilterByAgencyState(null);	
		
	} // end else
	
	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {};
	
	// Set LazyState
	setlazyState(currentData);	
	
} // end fucntion

const applyAdvancedSearch = () => {
	
	// Check if at least one field is filled
	if (!filterByTradingName && !filterByAgencyName && !filterByAgencyDocument && !filterByResponsibleName && !filterByResponsibleDocument && !filterByAgencyPhone &&  !filterByAgencyEmail && !filterByCreateAtFrom && !filterByCreateAtTo && 	!filterByComissionProfile && !filterByStatus && !filterByAgencyState && !filterByAgencyCity) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher ao menos um campo pra prosseguir com a busca.");	
		return;
	} // end if	
	
	// Check if createdAt From and To are filled 
	if (filterByCreateAtFrom || filterByCreateAtTo) {
		if (!filterByCreateAtFrom || !filterByCreateAtTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data de criação para prosseguir.");	
			return;
		}
	} // end if

	// Check if createdAt From and To are filled 
	if (filterByCreateAtFrom || filterByCreateAtTo) {
		if (!filterByCreateAtFrom || !filterByCreateAtTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data do serviço para prosseguir.");	
			return;
		}
	} // end if	
	
	// Check company document if ok
	if (filterByResponsibleDocument) {
		if (!validarCPF(filterByResponsibleDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CPF informado é inválido. Verifique novamente.");		
			return;
		}
	} // end if	

	// Check customer document if ok
	if (filterByAgencyDocument) {
		if (!validarCNPJ(filterByAgencyDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CNPJ informado é inválido. Verifique novamente.");	
			return;
		}
	} // end if		
	 	
	// Set filter on
	setBasicFilterStatus(false);
	
	// Clean Basic Search term
	setFilterValue("");
	
	// Set advanced filter off
	setAdvancedFilterStatus(true);
	
	// Set filter to lazyData
	var currentData = {...lazyState}	
	
	var filters = {};
	filters.mode = "advanced"; 
	filters.agencyTradingName = filterByTradingName ? filterByTradingName : null; 
	filters.agencyName = filterByAgencyName ? filterByAgencyName : null; 
	filters.agencyDocument = filterByAgencyDocument ? filterByAgencyDocument : null; 
	filters.responsibleName = filterByResponsibleName ? filterByResponsibleName : null; 
	filters.responsibleDocument = filterByResponsibleDocument ? filterByResponsibleDocument : null; 
	filters.agencyPhone = filterByAgencyPhone ? filterByAgencyPhone : null; 
	filters.agencyEmail = filterByAgencyEmail ? filterByAgencyEmail : null; 
	filters.createAtFrom = filterByCreateAtFrom ? filterByCreateAtFrom : null; 
	filters.createAtTo = filterByCreateAtTo ? filterByCreateAtTo : null; 
	filters.agencyState = filterByAgencyState ? filterByAgencyState : null; 
	filters.agencyCity = filterByAgencyCity ? filterByAgencyCity : null; 
	filters.comissionProfile = filterByComissionProfile ? filterByComissionProfile : null; 
	filters.status = filterByStatus ? filterByStatus : null; 

	
	// Apply filter on Data from service 
	let _lazyParams = { ...lazyState, filters:{ fields: filters, mode:"advanced" } };
	setlazyState(_lazyParams);	
	
	// Closes panel
	setAdvancedSearch(!advancedSearch)
	
} // end function
 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */

// Set selected columns
const onColumnsChange = (e) => {
	
	let _visibleColumns = [...visibleColumns];

	if (e.checked)
		_visibleColumns.push(e.value);
	else
		_visibleColumns.splice(_visibleColumns.indexOf(e.value), 1);

	setVisibleColumns(_visibleColumns);
}

// Datatable related controls START
const loadLazyData = () => {	
	setLoading(true);
	retrieveItemsList();	
};

// Run after mount component
React.useEffect(() => {

  // set scroll to top
  window.scrollTo(0, 1);
  
  // Load list
  retrieveItemsList();

  // Load dropdown values for advanced filter 
  retrieveDropdownsValues();  
      
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 

const onPage = (event) => {	
	setlazyState(event);
};

const onSort = (event) => {
	setlazyState(event);
};

const onFilter = (event) => {
	event['first'] = 0;
	setlazyState(event);
};
// Datatable related controls END

// Reacts when lazyState changes
React.useEffect(() => {
	loadLazyData();
}, [lazyState]);
 
// Set Currency format
let EURO = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'EUR',
});

// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 	

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"40px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "" : "64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Faturas / Pagamentos</div>
								
								<div style={{flex:3,display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center"}}>
								
									<div style={{padding:"10px",marginRight:"10px",fontSize:"14px"}}>  Filtrar a busca por: </div>
									<div style={{backgroundColor:"#FFF",padding:"10px",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px"}}> 
										<Dropdown id="filterOption" disabled={saving} value={filter} onChange={(e) => setFilter(e.value)} options={dropdownFilterItems} optionLabel="name" placeholder="Selecione o campo" style={{minWidth:isSpecialDesktop ? "200px" : "230px",textAlign:"left",fontSize:"14px"}} className="w100"></Dropdown>
									</div>
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<div style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
											<InputText id="filterValue" autoComplete="new-password" disabled={saving}  value={filterValue} onChange={(e) => setFilterValue(e.target.value)} placeholder="Termo da busca" tooltip="Digite o termo a ser buscado" tooltipOptions={{position: 'bottom',event: 'focus'}}  style={{borderTopRightRadius:0,borderBottomRightRadius:0,fontSize:"14px"}} />
											<Button labell="Buscar" icon="pi pi-search" style={{borderTopLeftRadius:0,borderBottomLeftRadius:0,height:"47px",fontSize:"14px"}} loading={saving} onClick={()=>{applyBasicSearch()}} />
											 
											{basicFilterStatus &&
											<>
												<Button outlined icon="pi pi-times" style={{height:"47px",fontSize:"14px",marginLeft:"5px"}} loading={saving} tooltip="Selecione para limpar a busca" tooltipOptions={{ showDelay: 500, position: 'bottom',event: 'over'}} onClick={()=>resetSearch("basic")} />
											</>
											}
											
									  </div>							
									</div>									
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<Button className="filterButton" badge={advancedFilterStatus ? <svg viewBox="0 0 24 24" width="12" height="12" style={{position:"absolute",right:"2px",top:"2px"}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCaredrediered" stredoke-width="0"></g><g id="SVGRepo_tredaceredCaredrediered" stredoke-linecap="redound" stredoke-linejoin="redound"></g><g id="SVGRepo_iconCaredrediered"> <path d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" fill="#FFF"></path> </g></svg> : ""} badgeClassName={advancedFilterStatus ? "p-badge-secondary" : "hidden"} icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14 4C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V13M10 4C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H13" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M10 16H6" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="18" cy="17" r="3" stroke="#814DE5" stroke-width="1.5"></circle> <path d="M20.5 19.5L21.5 20.5" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M2 10L7 10M22 10L11 10" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{height:"47px", width:"40px",fontSize:"14px"}} onClick={()=>setAdvancedSearch(!advancedSearch)} /> 
										
										<Button icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9 4V20M15 4V20M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => op.current.toggle(e)} />
										<OverlayPanel ref={op} style={{zIndex:"9999"}}>

										<div className="card flex flex-wrap justify-content-center gap-3" style={{display:"flex",flexDirection:"column",alignItems:"flex-start",justifyContent:"center",gap:"10px",padding:"15px"}}>

											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column1" name="agencyId" value="agencyId" onChange={onColumnsChange} disabled={true} checked={visibleColumns.includes('agencyId')} />
												<label htmlFor="column1" className="ml-2">Código</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column2" name="agency" value="agency" onChange={onColumnsChange} checked={visibleColumns.includes('agency')} />
												<label htmlFor="column2" className="ml-2">Agência</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column3" name="responsible" value="responsible" onChange={onColumnsChange} checked={visibleColumns.includes('responsible')} />
												<label htmlFor="column3" className="ml-2">Responsável</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column4" name="contacts" value="contacts" onChange={onColumnsChange} checked={visibleColumns.includes('contacts')} />
												<label htmlFor="column4" className="ml-2">Contatos</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column5" name="location" value="location" onChange={onColumnsChange} checked={visibleColumns.includes('location')} />
												<label htmlFor="column5" className="ml-2">Localidade</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column7" name="governmentData" value="governmentData" onChange={onColumnsChange} checked={visibleColumns.includes('governmentData')} />
												<label htmlFor="column7" className="ml-2">Dados da RFB</label>
											</div>			

											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column8" name="profile" value="profile" onChange={onColumnsChange} checked={visibleColumns.includes('profile')} />
												<label htmlFor="column8" className="ml-2">Perfil de comissão</label>
											</div>
											
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column6" name="createdAt" value="createdAt" onChange={onColumnsChange} checked={visibleColumns.includes('createdAt')} />
												<label htmlFor="column6" className="ml-2">Criada em</label>
											</div>
											<div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"center",gap:"10px"}}>
												<Checkbox inputId="column9" name="status" value="status" onChange={onColumnsChange} checked={visibleColumns.includes('status')} />
												<label htmlFor="column9" className="ml-2">Status da reserva</label>
											</div>											
											
										</div>

										</OverlayPanel> 	

										<Button icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M12 14L12 4M12 4L15 7M12 4L9 7" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>	} outlined severity="secondary" aria-label="Adicionar usuário" style={{marginLeft:"10px",height:"47px", width:"40px",fontSize:"14px"}} onClick={(e) => console.log("EXPORT TO EXCEL")} />										
										
									</div>
								
								</div>
							
							</div>

							<div className={!advancedSearch ? "advSearchPanel" : "advSearchPanel animate"} style={{width:"100%",backgroundColor:"whitesmoke",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-start",padding:advancedSearch ? "25px" : "0px"}}>
								
								<div style={{textAlign:"left",color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '26px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Busca avançada</div>
								<div style={{textAlign:"left",color: '#000', fontFamily: 'Titillium Web', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',paddingTop:"0px",marginBottom:"35px"}}>Preencha um ou mais campos e faça a busca</div>

								<Grid container spacing={4}>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText value={filterByAgencyName} onChange={(e) => setFilterByAgencyName(e.target.value)} id="filterByAgencyName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByAgencyName">Razão Social</label>
									</span>
								  </Grid>
								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText value={filterByTradingName} onChange={(e) => setFilterByTradingName(e.target.value)} id="filterByTradingName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByTradingName">Nome Fantasia</label>
									</div>
								  </Grid>

								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={filterByAgencyDocument} onChange={(e) => setFilterByAgencyDocument(maskCNPJ(e.target.value))}  onBlur={(e) => setFilterByAgencyDocument(maskCNPJ(e.target.value))} id="filterByAgencyDocument" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByAgencyDocument">CNPJ</label>
									</div>
								  </Grid>
								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label">
										<InputText  value={filterByResponsibleName} onChange={(e) => setFilterByResponsibleName(e.target.value)} id="filterByResponsibleName" autoComplete="new-password" className="w100" />
										<label htmlFor="filterByResponsibleName">Nome do Responsável</label>
									</div>
								  </Grid>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label" >
										<InputText  value={filterByResponsibleDocument} onChange={(e) => setFilterByResponsibleDocument(maskCPF(e.target.value))} onBlur={(e) => setFilterByResponsibleDocument(maskCPF(e.target.value))} id="filterByResponsibleDocument" autoComplete="new-password" style={{width:"100%"}} />
										<label htmlFor="filterByResponsibleDocument">CPF do Responsável</label>
									</span>		
								  </Grid>								  
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText  value={filterByAgencyPhone} onChange={(e) => setFilterByAgencyPhone(maskPhone(e.target.value))} id="filterByAgencyPhone" autoComplete="new-password"  className="w100" />
										<label htmlFor="filterByAgencyPhone">Telefone</label>
									</span>
								  </Grid>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText  value={filterByAgencyEmail} onChange={(e) => setFilterByAgencyEmail(e.target.value)} id="filterByAgencyEmail" autoComplete="new-password"  className="w100" />
										<label htmlFor="filterByAgencyEmail">Email</label>
									</span>
								  </Grid>								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<MultiSelect showClear value={filterByComissionProfile} onChange={(e) => setFilterByComissionProfile(e.target.value)} options={comissionProfilesOptions} optionLabel="name" placeholder="Selecione o perfil de comissão" className="w100" display="chip"></MultiSelect>
										<label>Perfil de comissão</label> 
									</div>									
								  </Grid>
								  <Grid item xs={12} sm={4} style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
									<span className="p-float-label" style={{width:"49%",marginRight:"5px"}}>
										<Calendar value={filterByCreateAtFrom} onChange={(e) => {setFilterByCreateAtFrom(e.target.value); setFilterByCreateAtTo("")}} showButtonBar locale="br"  id="fromDate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Criada de </label>
									</span>										
									<span className="p-float-label" style={{width:"49%"}}>
										<Calendar value={filterByCreateAtTo} minDate={filterByCreateAtFrom} onChange={(e) => setFilterByCreateAtTo(e.target.value)} showButtonBar locale="br"  id="todate" style={{width:"100%"}} inputStyle={{width:"100%"}} showIcon dateFormat="dd/mm/yy"  />
										<label>Criada até </label>
									</span>										
								  </Grid>
  
								  <Grid item xs={12} sm={4}>	
									<div className="p-float-label" style={{textAlign:"left"}}>
										<Dropdown showClear value={filterByAgencyState} onChange={(e) => setFilterByAgencyState(e.target.value)} options={agenciesStatesOptions} optionLabel="name" placeholder="Selecione a forma de pagamento" className="w100"></Dropdown>
										<label>UF</label>
									</div>									
								  </Grid>
								  <Grid item xs={12} sm={4}>
									<span className="p-float-label">
										<InputText  value={filterByAgencyCity} onChange={(e) => setFilterByAgencyCity(e.target.value)} id="filterByAgencyCity" autoComplete="new-password"  className="w100" />
										<label htmlFor="filterByAgencyCity">Cidade</label>
									</span>
								  </Grid>								  
								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
										<Dropdown showClear value={filterByStatus} onChange={(e) => setFilterByStatus(e.target.value)} options={[{"code":1,name:"Aprovada"}/*,{"code":2,name:"Reprovada"},{"code":3,name:"Cancelada"}*/,{"code":3,name:"Bloqueada"},{"code":9,name:"Excluída"}]} optionLabel="name" placeholder="Selecione o Status" className="w100"></Dropdown>
										<label>Status Cadastro</label>
									</div>										
								  </Grid>					

								  <Grid item xs={12} sm={12}>
									<div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",gap:"20px"}}> 
									
											<div style={{textAlign:"right",flex:1}}>
												<Button label="Limpar busca" icon="pi pi-trash" severity="danger" text onClick={()=>{resetSearch("advanced");setAdvancedSearch(!advancedSearch)}}  />
											</div>												
											
											<Button rounded outlined className="pT10" label="Fechar" onClick={()=>setAdvancedSearch(!advancedSearch)} />
																				
											<Button rounded className="pT10" label="Buscar" loading={saving} disabled={saving} onClick={()=>{applyAdvancedSearch()}} />		
									</div>
								  </Grid>
								  
								</Grid>							  

							</div>

							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>

									<div className="registerModalIntro" style={{padding:"1rem",width:"70%"}}> Abaixo você encontra todas as faturas emitidas e o pagamento atrelado a mesma. Para cada fatura você poderá visualizar os itens que foram cobrados e a forma de pagamento. Caso alguma fatura esteja pendente de pagamento, você pode abrir a mesma e realizar o pagamento.</div>	

									<Divider />											
								
									<DataTable selectionMode="rowClick"
																		
									lazy onPage={onPage}  emptyMessage="Nenhuma agência encontrada."
									onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
									onFilter={onFilter} filters={lazyState.filters} loading={loading} totalRecords={totalRecords}
									
									reorderableColumns reorderableRows stripedRows 
									onSelectionChange={(e) => selectAgencyAction(e.value)} value={rows} paginator rows={lazyState.rows} rowsPerPageOptions={[10, 25]} tableStyle={{ minWidth: '50rem'}}>
		
										{/* Fixed column */}
										<Column field="agencyId" header="Código" body={(data)=>bodyTemplate('agencyId',data)}></Column>
										
										{/* Dinamic columns */}
										{visibleColumns.map((col) => { 

											if (col == 'agency') {
												return(<Column field="companyName" header="Agência" sortable body={(data)=>bodyTemplate('agency',data)}></Column>)
											}

											if (col == 'responsible') {
												return(<Column field="CompanyPerson.completeName" header="Responsável" sortable  body={(data)=>bodyTemplate('responsible',data.CompanyPeople[0])}></Column>)
											}											

											if (col == 'contacts') {
												return(<Column field="contacts" header="Contatos" body={(data)=>bodyTemplate('contacts',data)}></Column>)
											}
											
											if (col == 'location') {
												return(<Column field="location" header="Localidade" body={(data)=>bodyTemplate('location',data)}></Column>)
											}
											
											if (col == 'governmentData') {
												return(<Column field="governmentData" style={{width:"20%"}} header="Dados da RFB" sortable body={(data)=>bodyTemplate('governmentData',data.CompanyDocumentMeta)}></Column>)
											}
											
											if (col == 'profile') {
												return(<Column field="profile" header="Perfil comissão / grupo" body={(data)=>bodyTemplate('profile',data)}></Column>)
											}
											
											if (col == 'createdAt') {
												return(<Column field="createdAt" header="Criada em" sortable body={(data)=>bodyTemplate('creationDate',data)}></Column>)
											}											
											
											if (col == 'status') {
												return(<Column field="status" header="Status" body={(data)=>bodyTemplate('status',data)}></Column>)
											}

										})}
										
									</DataTable>
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
		
    </div>
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Agency);	


